export const es = {
  es: {
    translation: {
      confirm_app_exit: '¿Estás seguro que quieres cerrar Mundo Tiburón Bebé para Niños?',
      button_exit: 'Cerrar',
      button_cancel: 'Cancelar',
      os_update: 'Intenta de nuevo después de actualizar la versión del TV OS más reciente. ',
      button_ok: 'OK',
      t_complete_app_update: 'Mundo Tiburón Bebé para Niños ha sido actualizado.',
      error_title: 'Hubo un error',
      error_unknown: 'Por favor reiniciar la app.',
      error_network_title: 'Conexión inestable.',
      error_network: 'Verifique su conexión de red e inténtelo de nuevo.',
      button_retry: 'Reintentar',
      confirm_continue_watching: '¿Quieres seguir viendo?',
      button_continue_watching: 'Continuar Viendo',
      button_from_beginning: 'Ver Desde el Principio',
      t_event_coming_soon: 'Preparando eventos.',
      data_fail: 'Hubo un error. \nPor favor reiniciar la app.',
      page_sign_in_header: 'Iniciar con el código QR',
      page_sign_in: 'Tienes que iniciar sesión para usar el servicio. \nEscanea el QR para iniciar sesión.',
      page_sign_in_code: 'Código de Verificación',
      page_sign_in_time: 'Tiempo Restante',
      oauth_confirm_code: 'Por favor revisar \nsi el código de verificación\nse coincide con la del TV',
      oauth_web_info: 'Navegador de internet',
      oauth_device_info: 'Información del dispositivo',
      oauth_accept_sign_in: 'Aceptar ingreso',
      oauth_sign_in_success: 'Registración del dispositivo verificado',
      oauth_sign_in_cancel: 'Registración del dispositivo cancelado',
      oauth_sign_in_fail: 'Error. \nPor favor intente de nuevo con el código QR.',
      oauth_sign_in_expired: 'Tiempo de acceso expirado. \nRe-escaneé el código QR del TV para ingresar.',
      menu_my: 'Mi Perfil',
      menu_home: 'Inicio',
      menu_story: 'Cuento',
      menu_song: 'Canción',
      menu_cinema: 'Cinema',
      menu_cinema_and_tv: 'Cinema & Series de TV',
      menu_ip: 'IP',
      menu_topics: 'Temas',
      menu_home_history: 'Recién Vistos',
      title_ai_videos: 'Videos Recomendados por IA',
      menu_home_new_content: 'Novedades',
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: 'No tienes suscripciones activas',
      mypage_menu_status_susbcribed: '<span class="text-secondary">Suscrito a Pinkfong Plus</span>',
      mypage_menu_benefits_unsusbcribed: 'Beneficios de Suscripción',
      mypage_menu_benefits_susbcribed: 'Beneficios Actuales',
      mypage_menu_benefits_01: 'Más de 20,000 series originales disponible',
      mypage_menu_benefits_02: 'Contenidos exclusivos actualizado regularmente',
      mypage_menu_benefits_03: 'Acceso en ambos TV y móvil\ncon solo una suscripción',
      mypage_menu_benefits_04: '¡Más de 30 apps de juegos de aprendizaje con acceso ilimitado',
      mypage_scan_to_subscribe: 'Suscribe escaneando el código QR',
      mypage_video_title: '¿Qué es Pinkfong Plus?',
      mypage_menu_terms: 'Términos y Condiciones',
      mypage_menu_event: 'Promoción',
      mypage_menu_support: 'Soporte',
      button_sign_out: 'Cerrar sesión',
      mypage_menu_event_coming_soon: 'Pronto disponible',
      mypage_menu_even_open: 'Abierto',
      terms_required_privacy: 'Política de Privacidad',
      terms_required_pinkfong: 'Términos de Servicio',
      terms_required_interactive: 'Términos de App Interactiva de Pinkfong',
      mypage_menu_device_info: 'Información del Dispositivo',
      page_device_info: 'Contáctanos con la siguiente información para poder solucionar tu problema más rápido.',
      page_device_info_model: 'Modelo Dispositivo',
      page_device_info_os: 'OS Plataforma',
      page_device_info_version: 'Versión del App',
      page_support: 'Para asistencia del servicio, por favor contactar.\ncs@pinkfong.com',
      caution_sign_out: 'Si cierras la sesión habrá limitaciones al acceso del servicio.',
      topic_category_all: 'All',
      player_language_button: 'Idioma',
    },
  },
};
